import { combineReducers, Reducer } from 'redux'
import { AuthReducer, authReducer } from './authReducer'
import { TutorReducer, tutorReducer } from './tutorReducer'
import { LessonsReducer, lessonsReducer } from './lessonsReducer'
import { TimeSlotsReducer, timeSlotsReducer } from './timeSlotsReducer'
import { TutorChannelReducer, tutorChannelReducer } from './tutorChannelReducer'
import { ChatMessagesReducer, chatMessagesReducer } from './chatMessagesReducer'
import { SlidesReducer, slidesReducer } from './slidesReducer'
import { lessonReducer, LessonReducer } from './lessonReducer'
import { LessonToolsReducer } from './lessonToolsReducer'
import { lessonToolsReducer } from './lessonToolsReducer'
import { UnitsReducer, unitsReducer } from './unitsReducer'
import { lessonPlansReducer, LessonPlansReducer } from './lessonPlansReducer'
import { KurrentoReducer, kurentoReducer } from './kurentoReducer'
import { ManageSlidesReducer, manageSlidesReducer } from './manageSlidesReducer'
import { JanusReducer, janusReducer } from './janusReducer'
import { exercisesReducer, ExercisesReducer } from './exercisesReducer'
export interface RootReducer {
  authReducer: AuthReducer
  tutorReducer: TutorReducer
  tutorChannelReducer: TutorChannelReducer
  lessonsReducer: LessonsReducer
  timeSlotsReducer: TimeSlotsReducer
  chatMessagesReducer: ChatMessagesReducer
  slidesReducer: SlidesReducer
  lessonReducer: LessonReducer
  lessonToolsReducer: LessonToolsReducer
  unitsReducer: UnitsReducer
  lessonPlansReducer: LessonPlansReducer
  kurentoReducer: KurrentoReducer
  manageSlidesReducer: ManageSlidesReducer
  janusReducer: JanusReducer
  exercisesReducer: ExercisesReducer
}

const rootReducer: Reducer<RootReducer> = combineReducers({
  authReducer,
  tutorReducer,
  tutorChannelReducer,
  lessonsReducer,
  timeSlotsReducer,
  chatMessagesReducer,
  slidesReducer,
  lessonReducer,
  lessonToolsReducer,
  unitsReducer,
  lessonPlansReducer,
  kurentoReducer,
  janusReducer,
  manageSlidesReducer,
  exercisesReducer
})

export default rootReducer
